import type { AppRouteRecordRaw } from '@/router/types'
import { useI18n } from '@/hooks/web/useI18n'
import { LAYOUT } from '@/router/constant'

const { t } = useI18n()

const BigScreenRoute: AppRouteRecordRaw = {
  path: '/myBuilding',
  name: 'MyBuilding',
  component: LAYOUT,
  meta: {
    title: t('router.mybuilding'),
    icon: 'control-platform',
    hideBreadcrumb: true,
    hideMenu: false,
    layout: 'empty',
    orderNo: 10,
    perCode: 'kedex:mybuilding'
  },
  children: [
    {
      path: 'traffic-insight',
      name: 'myBuilding-insight',
      component: () => import('@/views/myBuilding/trafficInsight.vue'),
      meta: {
        title: t('router.mybuildingInsight'),
        hideBreadcrumb: false,
        hideMenu: false,
        master: true,
        layout: 'empty',
        perCode: 'kedex:mybuilding:insight'
      }
    },
    {
      path: 'traffic-view',
      name: 'myBuilding-view',
      component: () => import('@/views/myBuilding/trafficView.vue'),
      meta: {
        title: t('router.mybuildingView'),
        hideBreadcrumb: false,
        hideMenu: false,
        master: true,
        layout: 'empty',
        perCode: 'kedex:mybuilding:view'
      }
    }
  ]
};

export default BigScreenRoute;
